interface CloudiaService {
  port: number;
  basePath: string;
  endpoints?: string[];
}
export class CloudiaServices {
  CUSTOMER_MANAGEMENT: CloudiaService = {
    port: 8098,
    basePath: 'customerManagement',
  };

  get(key: keyof CloudiaServices) {
    return this[key] as CloudiaService;
  }
}
